import { ProgramCreatedEntityReference as GeneratedProgramCreatedEntityReference } from "@/.generated/hey/v4b-backend/types.gen";
import { CreateProgramResponse } from "@/domains/v4b/program/program-creation.types";
import { brandNumber } from "@/utils/branded";

export function mapCreateProgramResponse(
  createdProgramEntityReference: GeneratedProgramCreatedEntityReference,
): CreateProgramResponse {
  return {
    id: brandNumber(createdProgramEntityReference.id),
    type: createdProgramEntityReference.type,
  };
}
